<template>
  <footer class="bg-background-darker flex h-16 w-full items-center justify-center">
    <div>Bottom text</div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
